import { render, staticRenderFns } from "./company-box.vue?vue&type=template&id=71d43f54&"
import script from "./company-box.vue?vue&type=script&lang=js&"
export * from "./company-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports